import { render, staticRenderFns } from "./FirstBuy.vue?vue&type=template&id=64a37414&scoped=true&"
import script from "./FirstBuy.vue?vue&type=script&lang=js&"
export * from "./FirstBuy.vue?vue&type=script&lang=js&"
import style0 from "./FirstBuy.vue?vue&type=style&index=0&id=64a37414&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a37414",
  null
  
)

export default component.exports